import { render, staticRenderFns } from "./RefundListCard.vue?vue&type=template&id=b5d83b98&"
import script from "./RefundListCard.vue?vue&type=script&lang=js&"
export * from "./RefundListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CDivider: require('@chakra-ui/vue').CDivider, CFlex: require('@chakra-ui/vue').CFlex})
